<div class="config-container shadow my-3">
  <h4 class="title configurator-subtitle collapse-button" (click)="toggleCollapse()">
    {{ 'workbench.plan-shapes.plan-number' | translate }} {{ index }}
  </h4>

  <div class="collapse-block" *ngIf="collapseIsVisible">
    <div class="configurator-cards-container">
      <div
        class="configurator-card"
        [ngClass]="{
          active: isShapeSelected(shape.id),
        }"
        *ngFor="let shape of shapes"
        (click)="selectShape(shape)">
        <ng-casto-img-loader
          [imgSrc]="workbenchService.apiUrl + shape.icon.path"
          [imgClass]="'configurator-card-img'"></ng-casto-img-loader>
        <p class="configurator-card-title">{{ shape.name }}</p>
      </div>
      <ng-casto-loader *ngIf="shapes == null"></ng-casto-loader>
    </div>

    <div class="container-fluid">
      <div class="row">
        <div class="col-11">
          <div class="section-form">
            <!-- Longueur -->
            <div class="form-row" *ngIf="sectionConfiguration.shape?.needDimensions">
              <div class="form-label">
                <label>{{ 'workbench.plan-shapes.length' | translate }}</label>
              </div>
              <div class="form-input">
                <div class="mm">
                  <input
                    type="number"
                    [min]="shapeContraint.minLength"
                    [max]="shapeContraint.maxLength"
                    spellcheck="false"
                    step="1"
                    [value]="sectionConfiguration.length"
                    [(ngModel)]="sectionConfiguration.length"
                    (ngModelChange)="checkDimensions(DimensionTypeEnum.Length)" />
                </div>
                <a
                  class="casto-tooltip"
                  [tooltip]="
                    'workbench.plan-shapes.min-max'
                      | translate: { min: shapeContraint.minLength, max: shapeContraint.maxLength }
                  "
                  >?</a
                >
              </div>
            </div>

            <!-- Largeur -->
            <div class="form-row" *ngIf="sectionConfiguration.shape?.needDimensions">
              <div class="form-label">
                <label>{{ 'workbench.plan-shapes.width' | translate }}</label>
              </div>
              <div class="form-input">
                <div class="mm">
                  <input
                    type="number"
                    [min]="shapeContraint.minWidth"
                    [max]="shapeContraint.maxWidth"
                    spellcheck="false"
                    step="1"
                    [value]="sectionConfiguration.width"
                    [(ngModel)]="sectionConfiguration.width"
                    (ngModelChange)="checkDimensions(DimensionTypeEnum.Width)" />
                </div>
                <a
                  class="casto-tooltip"
                  [tooltip]="
                    'workbench.plan-shapes.min-max'
                      | translate: { min: shapeContraint.minWidth, max: shapeContraint.maxWidth }
                  "
                  >?</a
                >
              </div>
            </div>

            <!-- Diameter -->
            <div class="form-row" *ngIf="sectionConfiguration.shape?.needDiameter">
              <div class="form-label">
                <label>{{ 'workbench.plan-shapes.diameter' | translate }}</label>
              </div>
              <div class="form-input">
                <div class="mm">
                  <input
                    type="number"
                    [min]="shapeContraint.minDiameter"
                    [max]="shapeContraint.maxDiameter"
                    spellcheck="false"
                    step="1"
                    [value]="sectionConfiguration.diameter"
                    [(ngModel)]="sectionConfiguration.diameter"
                    (change)="checkDimensions(DimensionTypeEnum.Diameter)" />
                </div>
                <a
                  class="casto-tooltip"
                  [tooltip]="
                    'workbench.plan-shapes.min-max'
                      | translate: { min: shapeContraint.minDiameter, max: shapeContraint.maxDiameter }
                  "
                  >?</a
                >
              </div>
            </div>

            <!-- Size -->
            <div class="form-row" *ngIf="getSquareMeter() !== null">
              <div class="form-label">
                <label>{{ 'workbench.plan-shapes.size' | translate }}</label>
              </div>
              <div class="form-input">
                <div class="m2">
                  <input type="number" disabled step="0.01" max="9" min="0" [value]="getSquareMeter()" />
                </div>
              </div>
            </div>

            <!-- Flip de la forme -->
            <div class="form-row" *ngIf="sectionConfiguration.shape?.shapeType === ShapeTypeEnum.Mushroom">
              <div class="form-label">
                <label>{{ 'workbench.plan-shapes.flip' | translate }}</label>
              </div>
              <div class="form-input">
                <div class="d-flex">
                  <span class="mr-2">{{ 'workbench.plan-shapes.yes' | translate }}</span>
                  <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      [(ngModel)]="sectionConfiguration.isFlip"
                      (change)="flipShape(sectionConfiguration)"
                      class="custom-control-input"
                      id="isFlip" />
                    <label class="custom-control-label" for="isFlip">{{
                      'workbench.plan-shapes.no' | translate
                    }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
